const initialState = {
  showExportModal: false,
  showPrintModal: false,
  showTaskingModal: false,
  showMeasureOptions: false,
  showMeasurementModal: false,
  showMapTool: false,
  showGeoAIModal: false,
  showDatePaginatorOption: false,
  MeasurementEnable: true,
  PinEnable: true,
  showMetadataModal: false,
  showReqInfoModal: false,
  showObliquesModal: false,
  showMapModal: false,
  compareTool: false,
  cityScanActive: false,
  streetScanActive: false,
  showChart: false,
  chartPoints: []
}

export default function settings(state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_ANNOTATION_MODAL':
      return {
        ...state,
        showExportModal: false,
        showPrintModal: false,
        showTaskingModal: false,
        showMeasurementModal: action.show,
        showMapModal: !action.show,
        showGeoAIModal: false,
      }
    case 'TOGGLE_EXPORT_MODAL':
      return {
        ...state,
        showExportModal: action.show,
        showPrintModal: false,
        showTaskingModal: false,
        showMeasurementModal: false,
        showMapModal: false,
        showGeoAIModal: false,
      }
    case 'TOGGLE_PRINT_MODAL':
      return {
        ...state,
        showExportModal: false,
        showPrintModal: action.show,
        showTaskingModal: false,
        showMeasurementModal: false,
        showMapModal: false,
        showGeoAIModal: false,
      }
    case 'TOGGLE_TASKING_MODAL':
      return {
        ...state,
        showExportModal: false,
        showPrintModal: false,
        showMeasurementModal: false,
        showTaskingModal: action.show,
        showGeoAIModal: false,
      }
    case 'TOGGLE_GEOAI_MODAL':
      return {
        ...state,
        showExportModal: false,
        showPrintModal: false,
        showTaskingModal: false,
        showMeasurementModal: false,
        showMapModal: false,
        showGeoAIModal: action.show,
      }
    case 'TOGGLE_MEASURE_OPTIONS':
      return {
        ...state,
        showMeasureOptions: action.show
      }
    case 'TOGGLE_MAP_TOOL':
      return {
        ...state,
        showMapTool: action.show
      }
    case 'TOGGLE_DATE_PAGINATOR':
      return {
        ...state,
        showDatePaginatorOption: action.show
      }
    case 'TOGGLE_MEASUREMENT_ENABLE':
      return {
        ...state,
        MeasurementEnable: action.show
      }
    case 'TOGGLE_PIN_ENABLE':
      return {
        ...state,
        PinEnable: action.show
      }
    case 'TOGGLE_METADATA_MODAL':
      return {
        ...state,
        showMetadataModal: action.show
      }
    case 'TOGGLE_OBLIQUE_MODAL':
      return {
        ...state,
        showObliquesModal: action.show
      }
    case 'TOGGLE_REQINFO_MODAL':
      return {
        ...state,
        showReqInfoModal: action.show
      }
    case 'TOGGLE_DATA_DOWNLOAD_MODAL':
      return {
        ...state,
        showDataDownloadModal: action.show,
        showExportModal: false,
        showPrintModal: false,
        showMeasurementModal: false,
        showTaskingModal: false,
        showGeoAIModal: false,
      }
    case 'TOGGLE_MAP_MODAL':
      return {
        ...state,
        showMapModal: action.show
      }
    case 'TOGGLE_COMPARE_TOOL':
      return {
        ...state,
        compareTool: action.compareTool
      }
    case 'TOGGLE_CHART':
      return {
        ...state,
        showChart: action.show
      }
    case 'TOGGLE_GUIDED_TOUR':
      return {
        ...state,
        showGuidedTour: action.show
      }
    case 'SET_CHART_POINTS':
      return {
        ...state,
        chartPoints: action.points
      }
    case 'SET_MAX_LEVEL':
      return {
        ...state,
        maxLevel: action.maxLevel
      }
    case 'SET_SELECTED_EDITING_ANNOTATION':
      return {
        ...state,
        editingAnnotation: action.editingAnnotation
      }
    case 'SET_HIDE_3D_TERRAIN':
      return {
        ...state,
        Hide3DTerrain: action.Hide3DTerrain
      }
    case 'SET_CITY_SCAN_ACTIVE':
      return {
        ...state,
        cityScanActive: action.cityScanActive,
      }
    case 'SET_STREET_SCAN_ACTIVE':
      return {
        ...state,
        streetScanActive: action.streetScanActive,
      }
    case 'SET_SITE_SCAN_ACTIVE':
      return {
        ...state,
        siteScanActive: action.siteScanActive,
      }
    // case 'SET_SIDE_PANEL':
    //   return {
    //     ...state,
    //     panel: panel
    //   }
    default:
      return state;
  }
}